import { marpMarkerIcon } from '../../../components/shared/vector-images';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const markerType = 'marpMarker';

const layer = {
  displayName: 'Safety notice',
  synonyms: '',
  group: 'standardMarker',
  typeUrl: 'safety-notice',
  icon: {
    baseShape: marpMarkerIcon,
    iconColor: '#fff',
    markerColor: '#B01515',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: false,
    owningMenu: 'safety-notice',
    order: 1000,
  },
  standardMarkerOptions: {
    markerType,
    allowCreation: false,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Safety Notice',
      itemTitleFunction: (item) =>
        (item && item.geoJson.properties.title) || 'Safety Notice',
    },
    creationOptions: {
      menuText: '',
      newTitle: '',
      titlePlaceholder: 'Title',
      markerTypeDescription: 'Share any other helpful information here...',
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType,
    id: marker.id,
    displayChat: true,
    displayUpVotes: false,
    // Hack put in place for https://www.notion.so/deckee/DoT-WA-Event-Notices-Final-Steps-d875112df09d4cb3acb95ba3820335ba
    title: marker?.content?.customTitle || 'Safety Notice',
    description:
      (marker.geoJson &&
        marker.geoJson.properties &&
        marker.geoJson.properties.title) ||
      '',
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);

export default layer;
